window.customJSON = {
    // Endpoint
    "endpointCognigy": {
        "link": null
    },
    // Logo
    "logo": {
        "src": null
    },
    // Avatar
    "avatar": {
        "link": null,
        "animations": []
    },
    // Menu
    "menu": {
        "headline": null,
        "payloads": []
    },
    // Fonts
    "fonts": []
}